import { jsx as i } from "react/jsx-runtime";
import { useMemo as s } from "react";
import d from "@emotion/is-prop-valid";
import { createTheme as u, ThemeProvider as T, useTheme as n } from "@mui/material/styles";
import g from "lodash/merge";
import { StyleSheetManager as l } from "styled-components";
import { THEME as P } from "./globals/constants.js";
import v from "./utils/customAccentColor.js";
import a from "./utils/getThemeDefinition.js";
const D = ({ children: t, variant: r = P.distechLight, StyleSheetManagerProps: f = void 0, customTheme: o = void 0, accentColor: m = void 0 }) => {
  const h = s(() => {
    let e = a(r);
    return o && (e = g(e, o)), m && (e = v(m, r)), u(e);
  }, [
    m,
    o,
    r
  ]);
  return /* @__PURE__ */ i(l, {
    shouldForwardProp: (e, p) => typeof p == "string" ? d(e) : !0,
    ...f,
    children: /* @__PURE__ */ i(T, {
      theme: h,
      children: t
    })
  });
}, H = n;
export {
  D as default,
  H as useTheme
};
